import { Anchor, Text } from "@mantine/core";

import { servicesBuilt } from "./util.tsx";

interface HeroShowcaseProps {
  isMobile?: boolean;
}

const HeroShowcase = ({ isMobile = false }: HeroShowcaseProps) => {
  return (
    <div
      className="hero-showcase-section"
      style={{
        marginTop: "3rem",
        marginBottom: "6rem",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "2rem" }}>
        <h3
          style={{
            fontSize: isMobile ? "1.5rem" : "2rem",
            fontWeight: 700,
            marginBottom: "0.5rem",
            background: "linear-gradient(135deg, #00c9a7, #0891b2)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Built with This Kit
        </h3>
        <Text size={isMobile ? "sm" : "md"} color="dimmed">
          Production-ready projects using this serverless AWS kit
        </Text>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile
            ? "1fr"
            : "repeat(auto-fit, minmax(280px, 1fr))",
          gap: isMobile ? "1rem" : "1.25rem",
        }}
      >
        {servicesBuilt.map(({ label, href, description }) => (
          <Anchor
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none",
              display: "block",
            }}
          >
            <div
              style={{
                border: "1px solid rgba(255, 255, 255, 0.1)",
                borderRadius: "12px",
                padding: isMobile ? "1rem" : "1.25rem",
                background: "rgba(255, 255, 255, 0.05)",
                transition: "all 0.3s ease",
                cursor: "pointer",
                height: isMobile ? "auto" : "180px",
                minHeight: isMobile ? "140px" : "180px",
                display: "flex",
                flexDirection: "column",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                const target = e.currentTarget;
                target.style.transform = "translateY(-4px)";
                target.style.boxShadow = "0 8px 24px rgba(0, 201, 167, 0.3)";
                target.style.borderColor = "#00c9a7";
                target.style.background = "rgba(0, 201, 167, 0.08)";
              }}
              onMouseLeave={(e) => {
                const target = e.currentTarget;
                target.style.transform = "translateY(0)";
                target.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.3)";
                target.style.borderColor = "rgba(255, 255, 255, 0.1)";
                target.style.background = "rgba(255, 255, 255, 0.05)";
              }}
            >
              <div style={{ flex: "0 0 auto", marginBottom: "0.75rem" }}>
                <Text
                  style={{
                    fontWeight: 600,
                    color: "#00c9a7",
                    fontSize: isMobile ? "0.95rem" : "1rem",
                    lineHeight: 1.3,
                  }}
                >
                  {label}
                </Text>
              </div>

              <div style={{ flex: "1 1 auto", overflow: "hidden" }}>
                <div
                  style={{
                    fontSize: isMobile ? "0.75rem" : "0.875rem",
                    lineHeight: 1.5,
                    color: "rgba(255, 255, 255, 0.7)",
                    display: "-webkit-box",
                    WebkitLineClamp: isMobile ? 3 : 4,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {description}
                </div>
              </div>
            </div>
          </Anchor>
        ))}
      </div>

      <div
        style={{
          marginTop: "1.5rem",
          textAlign: "center",
        }}
      >
        <a
          href="#"
          style={{
            textDecoration: "none",
          }}
        >
          <Text
            size="sm"
            style={{
              color: "rgba(255, 255, 255, 0.5)",
              fontStyle: "italic",
              textDecoration: "underline",
              textDecorationColor: "rgba(255, 255, 255, 0.3)",
            }}
          >
            Plus many more enterprise projects built on this kit (names
            confidential due to NDA). Contact me to learn more.
          </Text>
        </a>
      </div>
    </div>
  );
};

export default HeroShowcase;
